<template>
  <div class="section-overview">
    <vs-row>
      <div class="overview-posts" id="loadableContent-list-posts">
        <div class="table-title">
          <p>{{$t('dash.overview.title.posts')}}</p>
        </div>      
        <component-loader :progress="90" :unlimitedProgress="true" v-if="getLastPostsLoading"></component-loader>
        <div v-if="postsData && !postsData.length" class="list-wrapper">
          <p class="txt">{{$t('dash.overview.empty')}}</p>
        </div>
        <component-table
          v-if="postsData && !!postsData.length"
          :gridData="postsData"
          :columns="postsColumn"
          :name="'overview'"
        ></component-table>
        <vs-button
          class="posts-btn btn-large"
          color="#2F1937"
          vs-type="filled"
          size="large"
          type="submit"
          @click="go('posts')"
          v-if="postsData && postsData.length"
        >{{$t('dash.button.all')}}</vs-button>
      </div>
    </vs-row>

    <div class="row" v-if="['Admin', 'Editor'].includes(getUserRole)">
      <div class="overview-column">
        <div class="table-title">
          <p>{{$t('dash.overview.title.mine')}}</p>
        </div>
        <div class="list-pages">
          <component-list
            :gridData="pagesData"
            :columns="pagesColumn"
            :interaction="true"
            :name="'pages'"
            :disable="(x) => !checkLock(x.network)"
            v-on:edit-pages="go"
            v-on:post-clicked="goToPost"
          ></component-list>
        </div>
      </div>

      <div class="overview-column">
        <div class="table-title">
          <p>{{$t('dash.overview.title.active')}}</p>
        </div>
        <div class="list-news">
          <component-list
            :gridData="botsData"
            :columns="botsColumn"
            :interaction="false"
            :disable="(x) => !checkLock(x.page.network)"
            v-on:edit-posts="goToBot"
            :name="'posts'"
          ></component-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentTable from './../Table.vue'
import componentList from './../List.vue'
import componentLoader from './../overlay/Loader.vue'
import Posts from '../../mixins/Posts'
import Pages from '../../mixins/Pages'
import User from '../../mixins/User'
import Insights from '../../mixins/Insights'

import Queuer from '../../../utils/Queuer'

export default {
  name: 'overview',

  components: {
    componentTable,
    componentList,
    componentLoader
  },

  mixins: [Posts, Pages, Insights, User],

  beforeMount() {
    this.$ga.page(this.$router)
  },

  mounted: function() {
    console.log('test', this.section)
    if (this.getUserRole && this.getUserRole != 'Viewer' && (!localStorage.bots || !localStorage.bots.length || localStorage.linkedin_adding_page)) {
      localStorage.setItem('section', 'pages')
      this.$router.push({
        name: 'pages'
      })
    } else {
      localStorage.setItem('section', 'overview')
      this.getLastPosts()
      this.getPages()
      this.getBots()
    }
  },

  methods: {
    /**
     * View all posts
     *
     */
    go: function(section) {
      localStorage.setItem('section', section)
      this.$router.push({
        name: section
      })
    },

    /**
     * View all posts
     *
     */
    goToPost: function(page) {
      // Check user can create post for this network
      const { network } = this.pagesData.find(x => x.id === page)
      if (!this.checkLock(network)) {
        this.notifyNotPremium()
        return
      }
      localStorage.setItem('section', 'posts')
      this.$router.push({
        name: 'posts',
        params: {
          page: page
        }
      })
    },

    /**
     * View all posts
     *
     */
    goToBot: function(bot) {
      localStorage.setItem('section', 'bots')
      this.$router.push({
        name: 'bots',
        params: {
          bot: bot
        }
      })
    },

    /**
     * Get last posts
     */
    getLastPosts: async function() {
      console.log('enter get last posts')

      // if(!localStorage.user || localStorage.user == "undefined") 
      await this.fetchUserInfo()

      if(localStorage.user && localStorage.user != "undefined") {
        this.getLastPostsLoading = true
        //if (!localStorage.posts) {
        this.getPosts({}).then(res => {
          console.log('get last posts')
          // this.$vs.loading.close(`#loadableContent-list-posts > .con-vs-loading`)
          this.getLastPostsLoading = false
          const { success, posts } = res.body
          if (!success || success !== true) {
            this.dialog.title = 'Error'
            if (!res.body) {
              this.dialog.message = 'Server not responding…'
            } else {
              this.dialog.message = res.body.statusText
            }
            this.dialog.show = true
            return
          }
  
          this.postsData = posts.filter(p => p.page[0].status == 2)
  
          if(this.postsData && this.postsData.length && this.postsData != "undefined"){
            this.queue = new Queuer({
              data: JSON.parse(JSON.stringify(this.postsData)),
              task:(post) => {
                this.processInsights(post)
              }
            })
  
            this.queue.init()
          }
        })
      }

    },

    processInsights(post) {
      if(!post._bots.find(b => post.page[0].id && b.uid == post.page[0].id).page.isGroup){
        this.getInsights([post]).then(res => {
          res.body.posts[0].page.forEach(page => {
            let post = this.postsData.find(p => p._id == res.body.posts[0]._id && p.page[0].id == page.id )
            this.$set(this.postsData, this.postsData.indexOf(post), res.body.posts[0])
          })
  
          this.queue.unlock()
        })
      }
      else this.queue.unlock()
    },

    /**
     * Get my available pages
     */
    getPages: function() {
      const pages = localStorage.pages && localStorage.pages != "undefined" ? JSON.parse(localStorage.pages) : []
      this.pagesData = pages
    },

    /**
     * Get my available bots
     */
    getBots: function() {
      const allBots = localStorage.bots && localStorage.bots != "undefined" ? JSON.parse(localStorage.bots) : []
      this.botsData = allBots.filter(bot => this.pagesData.find(page => page.id == bot.page.id))
    }
  },

  data() {
    return {
      queue: null,

      postsColumn: ['pages', 'when', 'content', 'source', 'stats'],
      postsData: null,

      pagesColumn: ['pages', 'name'],
      pagesData: [],

      botsColumn: ['pages', 'name'],
      botsData: [],

      get section() {
        let section = localStorage.getItem('section')
        return section
      },
      
      getLastPostsLoading: false,
    }
  },

  computed: {
    getUserRole() {
      const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
      if(!user) return null
      if(user.admin)
        return 'Admin'
      else
        return user.role && user.role.length
                    ? user.role[0]
                    : 'Editor'
      
    }
  },

  watch: {
    section(){
      console.log('section change', this.section)
    }
  }
}
</script>
